import axios from "../../config/axios";
import {
  SHOW_BALANCE_SUCCESS,
  SHOW_BALANCE_FAILED,
  SHOW_BALANCE_INVALID_HASH,
  NETWORK_ERROR_BALANCE,
  LOADING_BALANCE,
  RESET_BALANCE,
  SET_SELECTED_CURRENCY,
} from "../types";

const showWalletBalance = (userData) => async (dispatch, getState) => {
  dispatch({ type: LOADING_BALANCE });


  const isFirstCall = !Object.values(getState().showWalletBalance.data).length;

  await axios
    .post("WalletServices/amountShow", userData)
    .then((res) => {
      switch (res.data.responseCode) {
        case "1":
          dispatch(success(res.data, isFirstCall));
          break;

        case "2":
          dispatch(fail(res.data));
          break;

        case "3":
          dispatch(invalid_hash(res.data));
          break;

        default:
          break;
      }
    })
    .catch((err) => dispatch({ type: NETWORK_ERROR_BALANCE, payload: err }));
};

function success(data, isFirstCall) {
  return {
    type: SHOW_BALANCE_SUCCESS,
    payload: { data, isFirstCall },
  };
}

function fail(data) {
  return {
    type: SHOW_BALANCE_FAILED,
    payload: data,
  };
}

function invalid_hash(data) {
  return {
    type: SHOW_BALANCE_INVALID_HASH,
    payload: data,
  };
}

const resetWalletBalance = () => {
  return {
    type: RESET_BALANCE,
  };
};

const setSelectedCurrency = (data) => {
  return {
    type: SET_SELECTED_CURRENCY,
    payload: data,
  };
};

export { showWalletBalance, resetWalletBalance, setSelectedCurrency };
